import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class IsExternalGuard  {
  constructor(private userService: UserService, private router: Router) { }
  async canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.userService.pendingWhoAmI; // Attendre que le whoAmI se termine
    if (this.userService.user?.isExternal) {
      this.router.navigate(['/consultants', this.userService.user.email, 'edit', 'profile']);
      return false;
    } else {
      return true;
    }
  }
}



